"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _useStylesUtils2 = require("../../hooks/useStylesUtils");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles(props) {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily,
    themeColors = _useContext.themeColors;
  var _useStylesUtils = (0, _useStylesUtils2.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem,
    fontSizeProps = _useStylesUtils.fontSizeProps;
  var isDisabled = props.isDisabled,
    _props$color = props.color,
    color = _props$color === void 0 ? 'primary' : _props$color,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    _props$isChecked = props.isChecked,
    isChecked = _props$isChecked === void 0 ? false : _props$isChecked,
    _props$verticalAlign = props.verticalAlign,
    verticalAlign = _props$verticalAlign === void 0 ? 'top' : _props$verticalAlign;
  var ccCheckboxStyle = (0, _react.useMemo)(function () {
    var disabledProps = function disabledProps() {
      if (isDisabled) {
        return {
          opacity: '.5',
          pointerEvents: 'none',
          cursor: 'default'
        };
      }
      return {};
    };
    var btnSizeProps = function btnSizeProps() {
      var width;
      var height;
      switch (size) {
        case 'small':
          height = width = pxToRem(14);
          break;
        case 'medium':
          height = width = pxToRem(16);
          break;
        case 'large':
          height = width = pxToRem(18);
          break;
      }
      return {
        width: width,
        height: height
      };
    };
    var btnCheckedColorProps = function btnCheckedColorProps() {
      if (isChecked) {
        var background = color === 'primary' ? themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main : themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.dark;
        var borderColor = color === 'primary' ? themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main : themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.dark;
        var textColor = color === 'primary' ? themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light : themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light;
        return {
          background: background,
          borderColor: borderColor,
          color: textColor
        };
      }
      return {};
    };
    var ccCheckbox = (0, _css.css)(_objectSpread(_objectSpread({
      display: 'flex',
      fontFamily: fontFamily,
      alignItems: verticalAlign === 'middle' ? 'center' : verticalAlign === 'bottom' ? 'end' : 'start',
      cursor: 'pointer'
    }, fontSizeProps(size)), disabledProps()));
    var ccCheckboxBtn = (0, _css.css)(_objectSpread(_objectSpread({
      position: 'relative',
      top: verticalAlign === 'bottom' ? 'auto' : pxToRem(verticalAlign === 'middle' ? 0 : 3.4),
      bottom: verticalAlign === 'top' ? 'auto' : pxToRem(verticalAlign === 'middle' ? 0 : 3.4),
      borderRadius: pxToRem(3),
      border: "1px solid ".concat(themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.subText),
      background: 'transparent',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexShrink: 0
    }, btnSizeProps()), btnCheckedColorProps()));
    var ccCheckboxLabel = (0, _css.css)({
      marginInlineStart: pxToRem(8)
    });
    return {
      ccCheckbox: ccCheckbox,
      ccCheckboxBtn: ccCheckboxBtn,
      ccCheckboxLabel: ccCheckboxLabel
    };
  }, [color, fontFamily, fontSizeProps, isChecked, isDisabled, pxToRem, size, themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.dark, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.subText, themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main, verticalAlign]);
  return {
    'cc-Checkbox': ccCheckboxStyle.ccCheckbox,
    'cc-Checkbox__btn': ccCheckboxStyle.ccCheckboxBtn,
    'cc-Checkbox__label': ccCheckboxStyle.ccCheckboxLabel
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;